// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"283":"1a434b94","355":"1a434b94","401":"1a434b94","483":"1a434b94","626":"1a434b94","695":"1a434b94","820":"1a434b94","917":"1a434b94"}[chunkId] + ".chunk.css";
};